import { AddressDTO } from '@services/DTO/AddressDTO'
import { AreaDTO } from '@services/DTO/AreaDTO'
import { BookingReasonDTO } from '@services/DTO/BookingReasonDTO'
import { BrandDTO } from '@services/DTO/BrandDTO'
import { CancellationReasonDTO } from '@services/DTO/CancellationReasonDTO'
import { ChargeRangeDTO } from '@services/DTO/ChargeRangeDTO'
import { CommunicationPreferencesDTO } from '@services/DTO/CommunicationPreferencesDTO'
import { DiaryPreferencesDTO } from '@services/DTO/DiaryPreferencesDTO'
import { EventDTO } from '@services/DTO/EventDTO'
import { QuestionDTO } from '@services/DTO/QuestionDTO'
import { ServiceStatusDTO } from '@services/DTO/ServiceStatusDTO'
import { VenueRuleDTO } from '@services/DTO/VenueRuleDTO'
import { VenueVelocityDTO } from '@services/DTO/VenueVelocityDTO'
import { WidgetConfigurationDTO } from '@services/DTO/WidgetConfigurationDTO'
import { BookingAssignment } from '@app/domain/BookingAssignment'
import { OpeningHoursDTO } from '@services/DTO/OpeningHoursDTO'

export class VenueDTO {
    constructor(
        public id: string,
        public displayName: string,
        public phoneNumber: string | null,
        public address: AddressDTO,
        public bookingInterval: number,
        public minPartySize: number | null,
        public minLargePartySize: number | null,
        public rules: VenueRuleDTO[],
        public largePartyMessage: string | null,
        public noBookingSlotAvailableMessage: string | null,
        public shortPreBookingWindowMessage: string | null,
        public dogFriendlyNoAvailabilityMessage: string | null,
        public bookingsPausedNoAvailabilityMessage: string | null,
        public venueClosedNoAvailabilityMessage: string | null,
        public timeZone: string,
        public cancellationChargeRanges: ChargeRangeDTO[],
        public depositChargeRanges: ChargeRangeDTO[],
        public cancellationChargeCutOffHours: number,
        public cancellationChargeAutomatically: boolean,
        public communicationPreferences: CommunicationPreferencesDTO,
        public depositRefundCutOffDays: number | null,
        public depositRefundPolicy: string | null,
        public diaryPreferences: DiaryPreferencesDTO,
        public velocity: VenueVelocityDTO,
        public widgetConfiguration: WidgetConfigurationDTO,
        public areas: AreaDTO[],
        public customerCanChooseArea: boolean | undefined,
        /** @deprecated Retained for backwards compatibility with older clients. */
        public areaBookingOrder: string[],
        public manualAcceptanceUntilDate: string | null,
        public brand: BrandDTO,
        public bookingPolicy: string | null,
        public largePartyBookingPolicy: string | null,
        public largePartyBookingPolicyMinimumPartySize: number | null,
        public enquiriesEnabled: boolean,
        public waitlistsEnabled: boolean,
        public emailValidationEnabled: boolean,
        public autoExtendSeatedBookingEndTimes: boolean,
        public enabledServiceStatuses: ServiceStatusDTO[],
        public voucherSoldEmailRecipients: string[] | null,
        public sendVoucherSoldMerchantEmail: boolean,
        public reasons: BookingReasonDTO[],
        public cancellationReasons: CancellationReasonDTO[],
        public questions: QuestionDTO[],
        public events: EventDTO[],
        public metaPixelId: string | null = null,
        public bookingAssignment: BookingAssignment | null = null,
        public description: string | null = null,
        public promotionalImageIds: string[] = [],
        public openingHours: OpeningHoursDTO | null = null,
        public privacyPolicy: string | null = null,
        public preorderMenuId: string | null = null
    ) { }
}
